import React, { VFC } from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { ActionButtonVariants } from 'components/action-button';
import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';

import {
  BackButtonContainer,
  StyledBackArrow,
  StyledBackButton,
} from './product-customization-back-button.styled';
import { IProductCustomizationBackButton } from './types';

export const ProductCustomizationBackButton: VFC<IProductCustomizationBackButton> = ({
  onBackButtonClick,
}) => {
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery(MediaQuery.Desktop);

  return (
    <>
      {isDesktop ? (
        <BackButtonContainer>
          <StyledBackButton
            startIcon={
              <Icon icon="previous" color="icon-header-contrast" width="24px" aria-hidden />
            }
            color="icon-header-contrast"
            variant={ActionButtonVariants.TEXT_ONLY}
            onClick={onBackButtonClick}
          >
            {formatMessage({ id: 'backToSummary' })}
          </StyledBackButton>
        </BackButtonContainer>
      ) : (
        <StyledBackArrow onClick={onBackButtonClick} />
      )}
    </>
  );
};
